import { useLocation, useParams } from 'react-router-dom';

import { type ProfileGroups, useProfileGroupsSchemas } from '@/core/api/profiles';

export interface ProfileLabelContext {
	singular: string;
	plural: string;
	singularCapitalized: string;
	pluralCapitalized: string;
}

export const useProfileLabelByContext = (): ProfileLabelContext => {
	const { data: profileGroups } = useProfileGroupsSchemas();
	const location = useLocation();
	const { groupLabel } = useParams<{ groupLabel: string }>();

	if (location.pathname === '/' && profileGroups?.groups) {
		const firstGroup = profileGroups.groups[0];
		const singularLabel = firstGroup.label.endsWith('s')
			? firstGroup.label.slice(0, -1)
			: firstGroup.label;

		return {
			singular: singularLabel.toLowerCase(),
			plural: firstGroup.label.toLowerCase(),
			singularCapitalized: singularLabel,
			pluralCapitalized: firstGroup.label,
		};
	}

	if (location.pathname === '/') {
		return {
			singular: 'account',
			plural: 'accounts',
			singularCapitalized: 'Account',
			pluralCapitalized: 'Accounts',
		};
	}

	if (groupLabel && profileGroups?.groups) {
		const currentGroup = profileGroups.groups.find(
			(group: ProfileGroups) => group.label.toLowerCase() === groupLabel.toLowerCase()
		);

		if (currentGroup) {
			const singularLabel = currentGroup.label.endsWith('s')
				? currentGroup.label.slice(0, -1)
				: currentGroup.label;

			return {
				singular: singularLabel.toLowerCase(),
				plural: currentGroup.label.toLowerCase(),
				singularCapitalized: singularLabel,
				pluralCapitalized: currentGroup.label,
			};
		}
	}

	return {
		singular: 'account',
		plural: 'accounts',
		singularCapitalized: 'Account',
		pluralCapitalized: 'Accounts',
	};
};
